import { render, staticRenderFns } from "./TahsilatList.vue?vue&type=template&id=e8c3d97c&scoped=true"
import script from "./TahsilatList.vue?vue&type=script&lang=ts"
export * from "./TahsilatList.vue?vue&type=script&lang=ts"
import style0 from "./TahsilatList.vue?vue&type=style&index=0&id=e8c3d97c&prod&lang=css"
import style1 from "./TahsilatList.vue?vue&type=style&index=1&id=e8c3d97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c3d97c",
  null
  
)

export default component.exports